import Vue from 'vue';
import {
    Empty,
    EmptyLocal,
    Modal,
    MyPagination,
    Poptip,
    Select
} from '@/components/index';

Vue.component('Empty', Empty);
Vue.component('EmptyLocal', EmptyLocal);
Vue.component('Modal', Modal);
Vue.component('MyPagination', MyPagination);
Vue.component('Poptip', Poptip);
Vue.component('Select', Select);
